import { forwardRef, useEffect, useRef, useImperativeHandle } from 'react';
import { DataState } from '../data-state';
import type { RouteStateProps } from './route-state.types';

const variantConfig = {
  'not-found': { tone: 'neutral' as const, live: 'off' as const },
  'invalid-route': { tone: 'warn' as const, live: 'off' as const },
  permission: { tone: 'neutral' as const, live: 'off' as const },
  error: { tone: 'danger' as const, live: 'assertive' as const },
};

export const RouteState = forwardRef<HTMLDivElement, RouteStateProps>(
  ({ variant, live, tabIndex, ...props }, ref) => {
    const internalRef = useRef<HTMLDivElement>(null);
    const config = variantConfig[variant];

    useImperativeHandle(ref, () => internalRef.current as HTMLDivElement);

    useEffect(() => {
      internalRef.current?.focus();
    }, []);

    return (
      <DataState
        ref={internalRef}
        {...props}
        data-route-state={variant}
        scale="page"
        tone={config.tone}
        live={live ?? config.live}
        tabIndex={tabIndex ?? -1}
        headingLevel={1}
      />
    );
  },
);

RouteState.displayName = 'RouteState';
